/**
 * Dialogue de saisie au pave numerique : quantite d'une ligne, nouveau prix.
 * `onValider` recoit le texte saisi et renvoie un message d'erreur, ou null
 * si la saisie est acceptee (le parent ferme alors le dialogue). Le parent
 * change la `key` du dialogue a chaque ouverture (etat neuf).
 */
import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import PaveSaisie from './PaveSaisie';
import { palette } from '../app/theme';

export default function DialogueSaisie({
    open, titre, sousTitre, suffixe = '', decimale = false, valeurInitiale = '', libelleValider = 'Valider',
    onValider, onAnnuler, actionSecondaire = null, testId = 'dialogue-saisie',
}) {
    // Etat neuf a chaque ouverture : l'ecran de vente change la `key` de ce dialogue.
    const [valeur, setValeur] = useState(valeurInitiale);
    const [erreur, setErreur] = useState(null);

    const valider = () => setErreur(onValider(valeur));

    return (
        <Dialog open={open} onClose={onAnnuler} disableRestoreFocus aria-labelledby={`${testId}-titre`} data-testid={testId}>
            <Box sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, minWidth: 380 }}>
                <Typography id={`${testId}-titre`} component="h2" sx={{ fontSize: 26, fontWeight: 800, color: palette.text, textAlign: 'center' }}>
                    {titre}
                </Typography>
                {sousTitre && <Typography sx={{ fontSize: 16, color: palette.textSecondary, textAlign: 'center' }}>{sousTitre}</Typography>}
                <Box
                    data-testid={`${testId}-valeur`}
                    aria-live="polite"
                    sx={{
                        width: '100%', height: 64, border: `3px solid ${palette.primary}`, borderRadius: 2, display: 'flex',
                        alignItems: 'center', justifyContent: 'flex-end', px: 2, fontSize: 32, fontWeight: 800, color: palette.text,
                    }}
                >
                    {valeur || '0'}{suffixe && ` ${suffixe}`}
                </Box>
                <Box role="alert" sx={{ minHeight: 24 }}>
                    {erreur && <Typography sx={{ fontSize: 16, fontWeight: 700, color: palette.errorOnTint }}>{erreur}</Typography>}
                </Box>
                <PaveSaisie valeur={valeur} onChange={setValeur} onValider={valider} decimale={decimale} />
                <Box sx={{ display: 'flex', gap: 1.5, width: '100%', mt: 1 }}>
                    <Button variant="outlined" onClick={onAnnuler} sx={{ flex: 1 }}>Annuler</Button>
                    <Button variant="contained" onClick={valider} sx={{ flex: 1 }}>{libelleValider}</Button>
                </Box>
                {actionSecondaire && (
                    <Button variant="text" onClick={actionSecondaire.onClick} sx={{ minHeight: 48 }}>{actionSecondaire.libelle}</Button>
                )}
            </Box>
        </Dialog>
    );
}
